//Scientific params
export const reduceFractions = true; //const used to defined default behavior with mathjs fraction

//define if lottie animations are disables mod then if true hide lottie animations
export const lottieByDefault = false;
export const maxTagsPerActivity = 8;
//COLOR SETTINGS
//MIMIC Color defined in variables.scss global var
//KEEP IT SYNCHRONISED WITH variables.scss
export const styleSettings = {
  color: {
    black: "#0A0A0A",
    dark: "#363636",
    gray: "#C1C1C1",
    light: "#F5F5F5",
    white: "#FFFFFF",
    primary: "#744DE0",
    link: "#3273DC",
    info: "#3AA6E9",
    success: "#48C774",
    warning: "#FFDD57",
    danger: "#FF3860",
    orange: "#FF8B3D",
  },
  colorRGBLatex: {
    purple: "0.431373,0.270588,0.870588", // = primary = convert rgb into decimal and /255 to have decimal [0,1]
    red: "1,0.219608,0.376471", //  = danger = [255/255,56/255,96/255]
    blue: "0.227451,0.65098,0.913725", // = info
    yellow: "1,0.866667,0.341176", // =warning
    green: "0.282353,0.780392,0.454902", // =success
    orange: "1,0.545098,0.239216", //=orange
  },

  //Geometry settings
  fillOpacity: 0.5,
  defaultSize: "medium",
  defaultFontSize: 18,
  fontSize: {
    small: "12",
    medium: "24",
    "x-large": "32",
    "xxx-large": "64",
  },
  defaultFixedPointSize: 2,
  defaultMovablePointSize: 6,
};
